import { useState, type ReactNode } from "react"

import { useInstitucionalPublico } from "../hooks/useInstitucionalPublico"
import { urlLogoInstitucional } from "../services/institucionalApi"

interface LogoInstitucionalProps {
  className?: string
  /** Conteúdo exibido quando não há logotipo cadastrado (ou falha ao carregar). */
  fallback?: ReactNode
  /** Cache-busting opcional; por padrão usa o `atualizadoEm` público. */
  versao?: string | null
}

/**
 * Logotipo institucional configurado em Cadastro → Dados institucionais.
 * Usado no cabeçalho e na tela de login. Sem logo (ou em erro), mostra o
 * `fallback`.
 */
export function LogoInstitucional({ className, fallback = null, versao }: LogoInstitucionalProps) {
  const { data } = useInstitucionalPublico()
  const [erro, setErro] = useState(false)

  if (!data?.temLogo || erro) {
    return <>{fallback}</>
  }

  return (
    <img
      src={urlLogoInstitucional(versao ?? data.atualizadoEm)}
      alt={data.nomeEmpresa || "Logotipo institucional"}
      className={className}
      onError={() => setErro(true)}
    />
  )
}
